import React from 'react';
import Miles from './Miles';
import CarStatistic from './CarStatistic';


function CenterStatistic(props) {
    return (
        <div className='centerStatistics'>
            <Miles />
            <CarStatistic/>
        </div>
    );
}

export default CenterStatistic;